import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'
import Flex from '@/shared/ui/Flex'

const ELEMENT_BORDER_RADIUS = `8px`

export const CreditTabSkeleton = () => (
	<Flex rowGap={32} column>
		<SkeletonLoader width={200} height={34} borderRadius={ELEMENT_BORDER_RADIUS} />
		<SkeletonLoader width={250} height={36} borderRadius={ELEMENT_BORDER_RADIUS} />
		<SkeletonLoader height={42} width={900} borderRadius={ELEMENT_BORDER_RADIUS} />
		<SkeletonLoader height={42} width={900} borderRadius={ELEMENT_BORDER_RADIUS} />
		<SkeletonLoader height={42} width={900} borderRadius={ELEMENT_BORDER_RADIUS} />
	</Flex>
)
